import { ArrowUpRight } from "lucide-react";
import { WAYS } from "@/data/content";
import { ICONS } from "@/components/icons";

export default function WaysToListen() {
  return (
    <section id="ways" className="bg-[#1B2C4E] text-white">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#3B82F6]">What we build</p>
        <h2 className="font-display text-3xl sm:text-4xl tracking-tight mt-3 uppercase max-w-3xl leading-[0.95]">
          Everything your product needs, end to end
        </h2>
        <p className="text-white/60 mt-5">With Radio App Consultancy, you get a partner across web, mobile, software and cloud.</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          {WAYS.map((w) => {
            const Icon = ICONS[w.icon];
            return (
              <div key={w.title} className="group relative rounded-2xl overflow-hidden h-80" data-testid={`way-${w.title.split(" ")[1] || w.title}`}>
                <img src={w.img} alt={w.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#26395F] via-[#26395F]/50 to-transparent" />
                <span className="absolute top-5 left-5 h-11 w-11 rounded-xl bg-[#3B82F6] flex items-center justify-center">
                  <Icon className="h-5 w-5 text-[#0F172A]" />
                </span>
                <div className="absolute bottom-0 p-7">
                  <h3 className="font-display text-2xl tracking-tight">{w.title}</h3>
                  <p className="text-sm text-white/70 mt-2">{w.text}</p>
                  <button className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#3B82F6] hover:text-white transition-colors">
                    Learn more <ArrowUpRight className="h-4 w-4" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
